import { render } from "./App.vue?vue&type=template&id=9a9f80c6"
const script = {}

import exportComponent from "/home/ubuntu/ciyc-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__